import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { PATHS } from "../../config/routePaths";

export default function Footer() {
  return (
    <footer className="landing-footer">
      <Container>
        <div className="landing-footer__grid">
          <div>
            <h2>Swarand</h2>
            <p>A place to read and publish.</p>
            <p className="mb-0">info@swarand.com</p>
          </div>
          <div>
            <h3>Company</h3>
            <ul>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to={PATHS.CONTACT}>Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <h3>Reading & writing</h3>
            <ul>
              <li><Link to={PATHS.browse()}>Catalog</Link></li>
              <li><Link to={PATHS.WRITERS}>Writers</Link></li>
              <li><Link to={PATHS.BECOME_WRITER}>Become a writer</Link></li>
              <li><Link to={PATHS.WRITER_PRICING}>Writer plans & pricing</Link></li>
            </ul>
          </div>
          <div>
            <h3>Legal</h3>
            <ul>
              <li><Link to={PATHS.PRIVACY}>Privacy Policy</Link></li>
              <li><Link to={PATHS.TERMS}>Terms & Conditions</Link></li>
              <li><Link to={PATHS.CANCELLATION_POLICY}>Cancellation Policy</Link></li>
            </ul>
          </div>
        </div>
        <p className="landing-footer-copy">&copy; {new Date().getFullYear()} Swarand. All rights reserved.</p>
      </Container>
    </footer>
  );
}
